import { useQuery } from "@tanstack/react-query";
import { getReleases } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
function useReleases() {
    const { rcbAuthenticationStore } = useStores();
    const releasesQuery = useQuery(QueryKeys.getReleases(), ({ signal })=>{
        return getReleases({
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            }
        });
    });
    return releasesQuery;
}
export { useReleases };
